import FormattedMessage from 'I18n/components/FormattedMessage';
import { Box } from 'foundations-components/transitional/components/Box';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { View } from 'foundations-components/transitional/components/View';
import { Component } from 'react';
// @ts-ignore untyped module
import SingleNameInput from '../internal/components/SingleNameInput';
import getNameOrder from 'I18n/utils/getNameOrder';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NameTypes = {
  GIVEN_NAME: 'GIVEN',
  FAMILY_NAME: 'FAMILY'
};
const NAME_LABELS = {
  [NameTypes.GIVEN_NAME]: () => /*#__PURE__*/_jsx(FormattedMessage, {
    message: "i18nAddon.fullNameInput.givenName"
  }),
  [NameTypes.FAMILY_NAME]: () => /*#__PURE__*/_jsx(FormattedMessage, {
    message: "i18nAddon.fullNameInput.familyName"
  })
};
class FullNameInput extends Component {
  render() {
    const {
      direction,
      wrap,
      familyNameInput,
      firstInputProps,
      givenNameInput,
      secondInputProps
    } = this.props;
    const nameOrder = getNameOrder();
    const firstInputType = nameOrder[0];
    const secondInputType = nameOrder[1];
    const firstLabel = NAME_LABELS[firstInputType];
    const secondLabel = NAME_LABELS[secondInputType];
    const isRow = direction === 'row';
    const wrapBoxMargin = isRow ? '100' : undefined;
    const flexBoxMargin = isRow ? '-100' : undefined;
    const containerMargin = isRow ? '-200' : undefined;
    let firstInput = givenNameInput;
    let secondInput = familyNameInput;
    if (firstInputType === NameTypes.FAMILY_NAME) {
      firstInput = familyNameInput;
      secondInput = givenNameInput;
    }
    return /*#__PURE__*/_jsx(View, {
      marginInlineEnd: containerMargin,
      children: /*#__PURE__*/_jsxs(TFlex, {
        direction: direction,
        wrap: wrap,
        align: "stretch",
        margin: flexBoxMargin,
        children: [/*#__PURE__*/_jsx(Box, {
          grow: 1,
          margin: wrapBoxMargin,
          children: /*#__PURE__*/_jsx(SingleNameInput, Object.assign({}, firstInputProps, {
            input: firstInput,
            label: firstLabel
          }))
        }), /*#__PURE__*/_jsx(Box, {
          grow: 1,
          margin: wrapBoxMargin,
          children: /*#__PURE__*/_jsx(SingleNameInput, Object.assign({}, secondInputProps, {
            input: secondInput,
            label: secondLabel
          }))
        })]
      })
    });
  }
}
FullNameInput.defaultProps = {
  direction: 'column',
  wrap: 'nowrap'
};
export default FullNameInput;